import { getTenant, getUserName } from '../helpers';
import { api } from './api';

export function populateCredentialViewData(credentialID, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
    getTenant(),
    getUserName(),
    getUserName(),
  )((err, data, response) => callback(filterCredential(response)));

  const filterCredential = (data) => {
    const filteredResult=  data.body[0]?.data.find(
      (result) =>
        result?.credentialDetails &&
        result?.credentialDetails?.entityId === credentialID
    );
    callback(filteredResult);

  }


}
